import { render, staticRenderFns } from "./ButtonPayment.vue?vue&type=template&id=bd745706"
import script from "./ButtonPayment.vue?vue&type=script&lang=js"
export * from "./ButtonPayment.vue?vue&type=script&lang=js"
import style0 from "./ButtonPayment.vue?vue&type=style&index=0&id=bd745706&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports